import { formatMoney } from '@betterment/core';
import { Separator } from '@betterment/samba-react';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../../graphql/fragments/activityItem.generated';
import { ActivityItemNode } from '../../../types';
import { ActivityDrawerLayout } from '../common/ActivityDrawerLayout';
import { StatusSection } from '../common/StatusSection';

export const Deposit: React.FC<{
  item: Extract<ActivityItemNode | ActivityItemFragment, { __typename: 'ActivityItemDeposit' }>;
}> = ({ item }) => {
  const { users } = item.subAccount;
  return (
    <ActivityDrawerLayout title="Deposit" users={users}>
      <DrawerListRow label="From" value={item.depositSourceAccount?.name ?? ''} />
      <Separator />
      <DrawerListRow label="To" value={item.depositDestinationAccount.name} />
      <Separator />
      <DrawerListRow label="Amount" value={item.amount ? formatMoney(item.amount) : ''} />
      <Separator />
      <DrawerListRow label="Note" value={item.memo ?? '—'} />
      <Separator />
      <StatusSection statuses={item.statuses} />
    </ActivityDrawerLayout>
  );
};
